
export default {
    getVagaCompetencia(state) {
        return state.competencia
    },
    getVagasCompetencias(state) {
        return state.competencias
    }
}